import { Global } from './../../core/Global'
import Adaptor from './../Adaptor'

const PREFIX = `${Global.baseURL}admin-panel/cash-mahan`

function notify(callBack, result) {
  if (typeof callBack === 'function') {
    callBack(result)
  }
}

function asError(err) {
  if (err && err.response && err.response.data) {
    return err.response.data
  }
  return {
    message: 'error',
    error: (err && err.message) || 'Request failed'
  }
}

function appendQuery(params) {
  if (!params) {
    return ''
  }
  const parts = []
  Object.keys(params).forEach((key) => {
    const value = params[key]
    if (value === undefined || value === null || value === '') {
      return
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  })
  return parts.length ? `?${parts.join('&')}` : ''
}

function get(path, params, callBack) {
  Adaptor.get(`${PREFIX}${path}${appendQuery(params)}`)
    .then((res) => notify(callBack, res))
    .catch((err) => notify(callBack, asError(err)))
}

function post(path, data, callBack) {
  Adaptor.post(`${PREFIX}${path}`, data || {})
    .then((res) => notify(callBack, res))
    .catch((err) => notify(callBack, asError(err)))
}

export default class CashMahanService {
  static getDashboard(callBack) {
    get('/dashboard', null, callBack)
  }

  static getPaymentRequests(params, callBack) {
    get('/payment-requests', params, callBack)
  }

  static getPaymentRequest(id, callBack) {
    get(`/payment-requests/${id}`, null, callBack)
  }

  static getSettlements(params, callBack) {
    get('/settlements', params, callBack)
  }

  static getSettlement(id, callBack) {
    get(`/settlements/${id}`, null, callBack)
  }

  static settle(id, data, callBack) {
    post(`/settlements/${id}/settle`, data, callBack)
  }

  static getWithdrawals(params, callBack) {
    get('/withdrawals', params, callBack)
  }

  static getWithdrawal(id, callBack) {
    get(`/withdrawals/${id}`, null, callBack)
  }

  static approveWithdrawal(id, data, callBack) {
    post(`/withdrawals/${id}/approve`, data || {}, callBack)
  }

  static rejectWithdrawal(id, data, callBack) {
    post(`/withdrawals/${id}/reject`, data, callBack)
  }

  static processingWithdrawal(id, data, callBack) {
    post(`/withdrawals/${id}/processing`, data || {}, callBack)
  }

  static completeWithdrawal(id, data, callBack) {
    post(`/withdrawals/${id}/complete`, data, callBack)
  }

  static failWithdrawal(id, data, callBack) {
    post(`/withdrawals/${id}/fail`, data, callBack)
  }

  static getTechnicianWallet(fixerId, callBack) {
    get(`/technicians/${fixerId}/wallet`, null, callBack)
  }
}
